(function () {
	// Each Rail section emits its own script tag, and duplicate tags with the
	// same src still execute once each. Without this guard every extra copy
	// would build a fresh instances map and double-initialise Swiper.
	if (window.btsRailLoaded) return;
	window.btsRailLoaded = true;

	var instances = new WeakMap();

	function num(el, key) {
		return parseInt(el.dataset[key], 10) || 0;
	}

	// 0 = in stock, 1 = sold out, so ascending puts sold-out last
	function soldOut(el) {
		return el.dataset.available === 'false' ? 1 : 0;
	}

	// Sold-out products sink to the end under every filter; the chosen sort
	// then applies within the in-stock group and within the sold-out group.
	function stockFirst(compare) {
		return function (a, b) {
			var byStock = soldOut(a) - soldOut(b);
			return byStock !== 0 ? byStock : compare(a, b);
		};
	}

	var COMPARATORS = {
		featured: stockFirst(function (a, b) {
			return num(a, 'featured') - num(b, 'featured');
		}),
		'price-asc': stockFirst(function (a, b) {
			var diff = num(a, 'price') - num(b, 'price');
			return diff !== 0 ? diff : num(a, 'featured') - num(b, 'featured');
		}),
		'price-desc': stockFirst(function (a, b) {
			var diff = num(b, 'price') - num(a, 'price');
			return diff !== 0 ? diff : num(a, 'featured') - num(b, 'featured');
		}),
	};

	function initRail(root) {
		if (instances.has(root)) return;

		if (typeof Swiper === 'undefined') {
			console.warn('[bts-rail] Swiper is unavailable, carousel not initialised.');
			return;
		}

		var section = root.closest('.bts-rail');
		if (!section) return;

		var perView = parseInt(root.dataset.slidesDesktop, 10) || 3;
		var prevEl = section.querySelector('.bts-rail__arrow--prev');
		var nextEl = section.querySelector('.bts-rail__arrow--next');
		var arrows = [prevEl, nextEl].filter(Boolean);

		var swiper = new Swiper(root, {
			slidesPerView: 1.15,
			spaceBetween: 16,
			watchOverflow: true,
			navigation: { nextEl: nextEl, prevEl: prevEl },
			breakpoints: {
				750: { slidesPerView: 2.2, spaceBetween: 20 },
				990: { slidesPerView: perView, spaceBetween: 20 },
			},
		});

		instances.set(root, swiper);

		// Swiper only adds a class at the ends; mirror it into aria-disabled and
		// pull the button out of the tab order so it is not a silent dead control.
		function syncArrows() {
			arrows.forEach(function (button) {
				var disabled = button.classList.contains('swiper-button-disabled');
				button.setAttribute('aria-disabled', disabled ? 'true' : 'false');
				button.tabIndex = disabled ? -1 : 0;
			});
		}

		if (arrows.length) {
			syncArrows();
			['slideChange', 'update', 'resize', 'toEdge', 'fromEdge'].forEach(function (evt) {
				swiper.on(evt, syncArrows);
			});
		}

		var buttons = section.querySelectorAll('.bts-rail__sort-btn');
		if (!buttons.length) return;

		buttons.forEach(function (button) {
			button.addEventListener('click', function () {
				var mode = button.dataset.sort;
				var comparator = COMPARATORS[mode];
				if (!comparator) return;

				var wrapper = root.querySelector('.swiper-wrapper');
				if (!wrapper) return;

				var slides = Array.prototype.slice.call(
					wrapper.querySelectorAll('.bts-rail__slide')
				);
				slides.sort(comparator);

				var fragment = document.createDocumentFragment();
				slides.forEach(function (slide) {
					fragment.appendChild(slide);
				});
				wrapper.appendChild(fragment);

				swiper.update();
				swiper.slideTo(0, 0);

				buttons.forEach(function (other) {
					var active = other === button;
					other.classList.toggle('is-active', active);
					other.setAttribute('aria-pressed', active ? 'true' : 'false');
				});
			});
		});
	}

	function initAll(scope) {
		(scope || document).querySelectorAll('[data-bts-rail]').forEach(initRail);
	}

	function destroyIn(scope) {
		if (!scope) return;
		scope.querySelectorAll('[data-bts-rail]').forEach(function (root) {
			var swiper = instances.get(root);
			if (swiper) {
				swiper.destroy(true, true);
				instances.delete(root);
			}
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	} else {
		initAll();
	}

	// Theme editor: re-init when a section is added or restyled
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});
	document.addEventListener('shopify:section:unload', function (event) {
		destroyIn(event.target);
	});
})();
